import { z } from 'zod';

import { BlockValueTemplateField } from '../../../../ConfigFields/CodeMirror/FlowTemplate';
import { OptionalStringSchema } from '../common';

export const OptionalBasePatientOrderParamsSchema = z.object({
  patientOrderId: OptionalStringSchema,
});

export function OptionalBasePatientOrderParamsFormFields() {
  return (
    <BlockValueTemplateField
      fieldName="config.payload.patientOrderId"
      label="Patient Order Id"
      helperText="Enter the reference to the Patient Order Id. e.g. `{{patient.data.providerUserId}}`"
      placeholder="e.g. {{order.data.patientOrderId}}"
    />
  );
}
